module.exports = __webpack_public_path__ + "static/a-prayer-to-my-father-orchestral-01-bca1edb372e4ce87dbace8019b12ba76.png";